import React from 'react';

import { Input, message, Form } from 'antd';
import api from '../../utils/api';
const { TextArea } = Input;

interface Props {
    quote_id: number;
    quote_notes: string;
}

export const QuoteNotes = ({ quote_id, quote_notes }: Props) => {
    const handleSubmit = async (value: string) => {
        try {
            await api.requests.patch(`/customer/quotes/${quote_id}/`, { notes: value });
        } catch (error: any) {
            message.error('Error Saving the Quote Notes Permission');
        }
    };

    return (
        <>
            <Form.Item label={'Quote Notes'}>
                <TextArea
                    maxLength={1000}
                    style={{ height: 90, width: 400 }}
                    defaultValue={quote_notes}
                    onChange={e => handleSubmit(e.target.value)}
                />
            </Form.Item>
        </>
    );
};
